module.exports = __webpack_public_path__ + "images/psp/FeaturedContentImages/militaryFeatured3.jpg";